>
<template>

    <section class="mentorship-connections">
        <div class="overlay" v-if="requestText" @click.prevent="requestText = null">
             <div class="overlay-content" @click.stop>
                <div class="close">
                    <i class="fa fa-times" @click.prevent="requestText = null"></i>

                </div>
                <h3>Message from student</h3>
                <div class="text-content" v-html="$options.filters.linkify(requestText)"></div>                

            </div> 
        </div>
        <div class="panel" v-if="requests">
            <div class="panel-heading">
                <h2 v-if="isMentor">Mentee Connections Initiated</h2>
                <h2 v-else>Mentor Connections Initiated</h2>
            </div>

            <div class="panel-body">

                <table class="table">
                    <thead>
                        <tr>
                            
                            <th></th>
                            <th v-if="isMentor">Student's Name</th>
                            <th v-else>Mentor's Name</th>
                            <th v-if="isMentor">Student's Email</th>
                            <th v-else>Mentor's Email</th>
                            <th>#1 Mentor's Approval</th>
                            <th>#2 Student's Choice</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody v-if="requests.length > 0">
                        <tr v-for="request in requests">
                            
                            <td v-if="isMentor"><i class="fa fa-envelope-o" @click.prevent="openRequestText(request)"></i><img class="avatar" :src="request.student.avatar"></td>
                            <td v-else><img class="avatar" :src="request.mentor.mentor_profile.avatar"></td>

                            <td v-if="isMentor">{{request.student.firstName}} {{request.student.lastName}}</td>
                            <td v-else>
                                <router-link :to="{name: 'mentorProfile', params:{id: request.mentor.id}}">
                                    {{request.mentor.firstName}} {{request.mentor.lastName}}
                                </router-link>
                            </td>

                            <td v-if="isMentor"><a :href="'mailto:'+request.student.email">{{request.student.email}}</a></td>
                            <td v-else><a :href="'mailto:'+request.mentor.email">{{request.mentor.email}}</a></td>

                            <td>
                                <span class="limbo" v-if="isMentor && request.approvedByMentor === null">
                                    Mentor Approved
                                    <i @click="updateRequest(request.id, true)" class="fa fa-check"></i>
                                    <i @click="updateRequest(request.id, false)" class="fa fa-remove"></i>
                                </span>

                                <span class="limbo disabled" v-if="!isMentor && request.approvedByMentor === null">
                                    Mentor Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                                <span class="approved" v-if="request.approvedByMentor === true">
                                    Mentor Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove inactive"></i>
                                </span>

                                <span class="declined" v-if="request.approvedByMentor === false">
                                    Mentor Approved
                                    <i class="fa fa-check inactive"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                            </td>

                            <td>

                                <span class="limbo" v-if="!isMentor && request.approvedByStudent === null && request.approvedByMentor !== false">
                                    Student Approved
                                    <i @click="updateRequest(request.id, true)" class="fa fa-check"></i>
                                    <i @click="updateRequest(request.id, false)" class="fa fa-remove"></i>
                                </span>

                                <span class="limbo disabled" v-if="isMentor && request.approvedByStudent === null">
                                    Student Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                                <span class="approved" v-if="request.approvedByStudent === true">
                                    Student Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove inactive"></i>
                                </span>

                                <span class="declined" v-if="request.approvedByStudent === false">
                                    Student Approved
                                    <i class="fa fa-check inactive"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                            </td>


                            <td class="status">
                                {{status(request)}}
                                <i 
                                    v-if="(localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')) 
                                    &&
                                    (request.approvedByMentor !== true && request.approvedByMentor !== false)                                     
                                    &&
                                    (status(request) === 'Waiting on them' || status(request) === 'Full')"
                                    @click.prevent="deleteRequest(request)"
                                    class="fa fa-trash"></i>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td></td>
                        <td colspan="6">No connections made yet</td>
                    </tr></tbody>

                </table>

            </div>

        </div>
    </section>

</template>


<script>

import mentors from '../services/mentors';

import toastr from 'toastr';
import { uniqBy } from 'lodash';

export default {
    data() {
        return {
            requests:null,
            requestText:null,
        }
    },
    mounted() {
        this.getRequests();
    },
    methods: {
        openRequestText(request) {
            this.requestText = request.text
        },       
        getRequests() {
            var self = this;
            mentors.getRequests(this).then(function(response) {
                self.requests = uniqBy(response.data.requests, (r) => r.id);
            });
        },
        updateRequest(id, change) {
            let action = change ? 'approve' : 'deny'            
            this.$swal({                
                text: `Please confirm that you want to ${action} this connection`,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                background:'#222',
                color:'#fcffff',            
                confirmButtonColor: '#33ccff',
                customClass:'swal-white-text-visible'
            }).then(()=>{                
                mentors.updateRequest(this, id, change).then((response) => {
                    response.data.success === true ? toastr.success('Updated') : toastr.error(response.data.message || 'Error updating');
                    this.getRequests();
                });
            }, (dismiss)=>{
                
            })
            return;
            
        },
        deleteRequest(request) {
            this.$swal({                
                text: `Please confirm that you want to delete this connection`,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(()=>{                
                mentors.deleteRequest(request.id).then((response) => {
                    response.data.success === true ? toastr.success('Deleted') : toastr.error(response.data.message || 'Error deleting');
                    this.requests = null;
                    this.getRequests();
                });
            }, (dismiss)=>{
                
            })
            return;
            

        },
        status(request) {

            if (!localStorage.roles.includes('Mentor')) {               
                const seats = request.mentor.mentor_profile.mentor_availabilities[0].seats;
                const taken = request.mentor.mentor_requests.filter(r => r.approvedByStudent === true && r.approvedByMentor === true);
                if (taken.length >= seats) {
                    return 'Full';
                }
            }
            if (request.approvedByMentor === true && request.approvedByStudent === true) {
                if (localStorage.roles.includes('Mentor')) {
                    if (request.mentorId == localStorage.user_id) {
                        return 'Mentorship approved';
                    } else {
                        return 'Taken';
                    }
                }
                else {

                    return 'Mentorship Approved';
                }
            }

            if (localStorage.roles.includes('Mentor')) {
                if (request.approvedByMentor === null) {
                    return 'Waiting on you';
                }
                if (request.approvedByMentor === false) {
                    return 'Closed'
                }
                if (request.approvedByStudent === null) {
                    return 'Waiting on them';
                }
            }

            if (!localStorage.roles.includes('Mentor')) {
                if (request.approvedByMentor === null) {
                    return 'Waiting on them';
                }
                if (request.approvedByMentor === false) {
                    return 'Closed'
                }
                if (request.approvedByStudent === null) {
                    return 'Waiting on you';
                }
            }

            return 'Closed';
        }
    },
    computed: {
        isMentor() {
            return localStorage.roles.includes('Mentor');
        }
    }
}
</script>

<style lang="scss">
    .swal-white-text-visible {
        .swal2-buttonswrapper button.swal2-styled {
            color:#212121!important;
        }
        .swal2-content {
            color:#b0b0b0!important;        
        }
    }
</style>
<style lang="scss" scoped>
    table {
        td {
            text-align:left;
            vertical-align:inherit!important;
        }
        i {
            cursor:pointer;
            font-size:2rem;
        }
        th {
            font-weight:100;
            font-size:1.3em;
            padding: 2.5rem 0!important;
        }
    }
    .disabled {
        color:#595959;
        i {
            pointer-events: none;
        }
    }
    .fa-envelope-o {
        margin-left:1rem;
        position:relative;
        top:4px;
    }
    .avatar {
        position:relative;
        top:.1rem;
        left:1rem;
        width:50px;
        height:50px;
        border-radius:50%;
        object-fit:cover;
    }

    .approved {
        color: green;
    }
    .declined {
        color: red;
    }
    .inactive {
        color: grey;
    }
    td.status {
        display:flex;
        align-items:center;
        justify-content:space-between;
        height:66px;        
        padding-right:2rem;
        i {
            cursor:pointer;
        }
    }
    .text-content {
        white-space: pre-wrap;
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }
    .overlay-content {
        background: #222;
        padding: 2rem;
        border-radius: 8px;
        max-width: 800px;
        width: 90%;
        max-height: 80%;
        overflow-y: auto;
        i {
            color:#fff;
        }
    }
    .open-text {
        padding-left:1rem;
    }
</style>



// WEBPACK FOOTER //
// MentorConnections.vue?098b2d56